import { Injectable } from '@angular/core';
import { languageApi } from 'app/layout/common/languages/languages-api';
import { TranslocoService } from '@jsverse/transloco';
import { tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LanguageService {
    constructor(
        private languageApi: languageApi,
        private transloco: TranslocoService
    ) {}

    updateCurrentUserLanguage(language: string) {
        return this.languageApi.patch(language).pipe(
            tap(() => {
                this.transloco.setActiveLang(language);
            })
        );
    }
}
